<script>
    let { children } = $props();
</script>

<section
    class="m-0 max-h-[90dvh] min-h-30 max-w-[90dvw] min-w-80 overflow-x-hidden
            overflow-y-auto rounded-xl
            bg-white p-4 shadow-xl">
    {@render children?.()}
</section>
